import React from 'react';
import tpl from '../templates/ut-card';
import CreditCardsModel from '../../Cards/models/greenCards.m';
import BaseNewCardView from '../../Cards/views/BaseNewCardView';
import {apiback} from '../../../config';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            model: {},
            tab: 'tariffs',
            tabPartners: 'wog'
        };
    }

    togglePartnersTab = tab => {
        this.setState({tabPartners: tab});
    };

    componentWillMount() {
        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new CreditCardsModel(json.data['green_card'])
                })
            );
    }

    static displayName = 'UkrainiansTogetherCard.Views.Main';
}
